import { useQuery } from '@tanstack/react-query'
import client from 'enrollment-platform/api/eps.client'
import { DateTimeFormats, convertToLocalFromUTCISODate } from 'helpers/datetime'

export default function useAssistedPayrollDetail(id: number) {
  async function onViewPayrollDetails(id: number) {
    try {
      const response = await client.get(`/payroll/manual/${id}/details`)
      return response.data.map((item) => ({
        label: convertToLocalFromUTCISODate(
          item.createdAt,
          DateTimeFormats.c,
          DateTimeFormats.c
        ),
        children: item.message,
        artifactId: item.id,
      }))
    } catch (err) {
      console.error(err)
      return []
    }
  }

  const { isPending, data, error } = useQuery({
    queryKey: ['getAssistedPayrollDetails', id],
    queryFn: () => onViewPayrollDetails(id),
  })
  return {
    isPending,
    data: data ?? [],
    error,
  }
}
